import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import ArchivedBidList from "../components/archivedBidLists";

const ArchivedBids = () => {
    return (
        <Box>
            <CustomAppBar active="archived"/>
            <ArchivedBidList/>
        </Box>
    );
}

export default ArchivedBids;